/**
 * WARNING: Ce fichier est nécessaire au bon fonctionnement de l'app !
 * Ne pas renommer / déplacer / supprimer le fichier
 * Ne pas renommer ou supprimer les variables exportées
 * Suivre les commentaires dans le code pour éditer le fichier
 */
import { useApolloClient } from '@apollo/client';
// import { BusinessQuery, CreateBusiness } from '../graphql/index.js';

export const useCustomHandlers = () => {
  const client = useApolloClient();

  // add your custom handlers here
  // those handlers will be available in your view components from `useProcess` hook, property `processHandlers`

  // to remove when adding custom handlers
  void client;

  // Example of a custom handler declaration that consumes a gql query
  // const onGetBusiness = async () => {
  //   const { data } = await client.query({
  //     query: BusinessQuery,
  //   });
  //
  //   return data.business.business;
  // };

  // Example of a custom handler declaration that consumes a gql mutation
  // const onCreateBusiness = async (input) => {
  //   const { data } = await client.mutate({
  //     mutation: CreateBusiness,
  //     variables: {
  //       input
  //     }
  //   });
  //
  //   return data.createBusiness.business;
  // };

  const customHandlers = {
    // add your custom handlers here
    // onGetBusiness,
    // onCreateBusiness
  };

  return {
    customHandlers
  };
};
